import React from 'react'
import { Table, Space, Button, Tag, Popconfirm, message } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import { ListComponent, BaseListComponentProps } from '../BaseComponent'
import { AdoptionApplicationCheckoutRemoveProductRequest } from '../../services/api/interfaces/ApiRequest'

type CheckoutProductListProps = BaseListComponentProps & {
  application_uuid: string,
  products: any,
  
  loading: boolean,
  adoptionApplicationCheckoutRemoveProduct: (args: AdoptionApplicationCheckoutRemoveProductRequest) => void,
}

export default class CheckoutProductList extends ListComponent<CheckoutProductListProps> {

  static defaultProps = {
    loading: false
  }

  state = {
    saving: false
  }

  tableColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: any, b: any) => a.name - b.name
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.description - b.description
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.price - b.price,
      render: (text: string, record: any) => {
        return <Tag color="green">$ {text}</Tag>
      }
    },
    {
      title: 'Required',
      dataIndex: 'required',
      key: 'required',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.required - b.required,
      render: (text: string, record: any) => (
        <Tag color={record.required ? 'orange' : 'purple'}>{record.required ? 'Yes' : 'No'}</Tag>
      )
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text: string, record: any) => (
        <Space size='middle'>
          <div ref={(refs) => this.actionRefs.delete.push(refs)}>
            <Popconfirm
              title="Are you sure about removing this product from checkout?"
              onConfirm={() => this.handleRemoveProduct(record.uuid)}
            >
              <Button
                type="dashed"
                shape="round"
                icon={<DeleteOutlined />}
              />
            </Popconfirm>
          </div>
        </Space>
      )
    }
  ]

  componentDidMount() {
    this.validateAccessPermissions()
  }

  componentDidUpdate(prevProps, prevState) {
    this.validateAccessPermissions()

    if (prevProps.loading && !this.props.loading && this.state.saving) {
      this.setState({
        saving: false
      }, () => {
        message.success('Checkout product removed successfully!')
      })
    }
  }

  handleRemoveProduct = (product_uuid: string) => {
    const { application_uuid, adoptionApplicationCheckoutRemoveProduct } = this.props

    const payload = {
      application_uuid,
      product_uuid
    }

    adoptionApplicationCheckoutRemoveProduct(payload)
    this.setState({
      saving: true
    })
  }

  render() {
    const { loading, products } = this.props

    return (
      <>
        <Table
          loading={loading}
          rowKey='uuid'
          columns={this.tableColumns}
          dataSource={products}
        />
      </>
    )
  }
}
